(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tapora-fit-finder"] && !Shopify.designMode) return;
  try {
    class TaporaFitFinder extends HTMLElement {
      connectedCallback() {
        this.capacity = parseInt(this.dataset.capacity, 10);
        this.verdict = this.querySelector('[data-tapora-fit-verdict]');
        if (!this.capacity || !this.verdict) return;

        this.addEventListener('change', (e) => {
          if (e.target.type !== 'radio') return;
          this.render(parseInt(e.target.value, 10));
        });
      }

      render(n) {
        const cap = this.capacity;
        let text;
        let tone = 'yes';

        if (n <= cap) {
          text = `Good fit. This one is sized for up to ${cap} bird${cap === 1 ? '' : 's'}.`;
        } else if (n === cap + 1) {
          text = `Tight. It is rated for ${cap}, so ${n} only works if they free-range through the day.`;
          tone = 'maybe';
        } else {
          text = `Too small — it is rated for ${cap}. We would rather tell you now than ship you the wrong thing.`;
          tone = 'no';
        }

        this.verdict.textContent = text;
        this.verdict.dataset.tone = tone;
      }
    }

    if (!customElements.get('tapora-fit-finder')) {
      customElements.define('tapora-fit-finder', TaporaFitFinder);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tapora-size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tpScInit) return;
    window.__tpScInit = true;
    var UK = [6, 8, 10, 12, 14, 16, 18];
    function root() { return document; }
    function data() { var n = document.querySelector('[data-tp-sc-data]'); try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } }
    function selectedSize() {
      var f = [].slice.call(document.querySelectorAll('fieldset')).filter(function (x) { var l = x.querySelector('legend'); return l && /^size$/i.test(l.textContent.trim()); })[0];
      if (!f) return null;
      var c = f.querySelector('input:checked');
      return c ? c.value : null;
    }
    var LAB = { chest: 'Chest', shoulder: 'Shoulder', length: 'Length', sleeve: 'Sleeve', waist: 'Waist', hem: 'Hem', hip: 'Hip' };
    function ease(d) { return (d.ease && d.ease[d.fit]) || 16; }
    function pick(d, u) {
      var need = d.bust[u] + ease(d);
      for (var i = 0; i < d.sizes.length; i++) if (d.sizes[i].chest >= need) return { i: i, room: d.sizes[i].chest - d.bust[u], enough: true };
      var l = d.sizes.length - 1; return { i: l, room: d.sizes[l].chest - d.bust[u], enough: false };
    }
    function ukRange(d, i) {
      var lo = null, hi = null;
      UK.forEach(function (u) { var need = d.bust[u] + ease(d); var ok = d.sizes[i].chest >= need, prev = i > 0 && d.sizes[i - 1].chest >= need; if (ok && !prev) { if (lo == null) lo = u; hi = u; } });
      return lo == null ? '–' : (lo === hi ? String(lo) : lo + '–' + hi);
    }
    var state = { uk: null };
    function hideOldTable() {
      [].slice.call(document.querySelectorAll('.rte table, .text-block table')).forEach(function (t) {
        if (t.closest('[data-tp-sc-guide]')) return;
        if (/usually fits|chest|bust/i.test(t.textContent) && /shoulder|sleeve|length/i.test(t.textContent)) t.classList.add('tp-sc--hidden-old');
      });
    }
    function update() {
      var r = root(); var d = data(); if (!d) return;
      var sel = selectedSize(), strip = r.querySelector('[data-tp-sc-strip]'), rows = [].slice.call(r.querySelectorAll('[data-tp-sc-guide] tbody tr'));
      var ans = state.uk ? pick(d, state.uk) : null;
      rows.forEach(function (row, i) { var cell = row.querySelector('[data-uk-cell]'); var uk = ukRange(d, i); if (cell && cell.textContent !== uk) cell.textContent = uk; var hit = (sel && row.getAttribute('data-size') === sel) || (ans && ans.i === i); row.classList.toggle('is-hit', !!hit); });
      var s = d.sizes.filter(function (x) { return String(x.size) === String(sel); })[0];
      var stripHtml = s ? '<b>' + s.size + '</b>' + d.cols.map(function (c) { return s[c] != null ? '<span>' + LAB[c] + ' ' + s[c] + ' cm</span>' : ''; }).join('') : '<span class="tp-sc__dim">Choose a size to see its measurements here.</span>';
      if (strip && strip.__h !== stripHtml) { strip.innerHTML = stripHtml; strip.__h = stripHtml; }
      var v = r.querySelector('[data-tp-sc-verdict]');
      var vHtml = ans ? (ans.enough ? '<b>Size ' + d.sizes[ans.i].size + '</b> for a UK ' + state.uk + '. Its chest of ' + d.sizes[ans.i].chest + ' cm leaves ' + ans.room + ' cm of room over a typical UK ' + state.uk + ' bust.' : '<b>Size ' + d.sizes[ans.i].size + '</b> is the nearest for a UK ' + state.uk + '. Its chest of ' + d.sizes[ans.i].chest + ' cm leaves ' + ans.room + ' cm of room over a typical UK bust; compare it with a coat you own using the box below.') : 'Tap your UK size and we will show the size to order.';
      if (v && v.__h !== vHtml) { v.innerHTML = vHtml; v.__h = vHtml; }
      [].slice.call(r.querySelectorAll('[data-uk]')).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-uk') === state.uk)); });
      hideOldTable();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-tp-sc-guide] [data-uk]');
      if (b) { var u = +b.getAttribute('data-uk'); state.uk = state.uk === u ? null : u; update(); }
    });
    document.addEventListener('change', function () { setTimeout(update, 30); setTimeout(update, 400); });
    document.addEventListener('input', function (e) {
      if (!(e.target && e.target.matches && e.target.matches('[data-tp-sc-own]'))) return;
      var r = root(), d = data(), out = r.querySelector('[data-tp-sc-ownout]'), v = parseFloat(String(e.target.value).replace(',', '.'));
      if (!v || v < 30 || v > 90) { out.textContent = 'Lay your coat flat, measure straight across the chest from armpit to armpit, and type it here.'; return; }
      var all = v * 2, best = d.sizes.reduce(function (a, s) { return Math.abs(s.chest - all) < Math.abs(a.chest - all) ? s : a; }), diff = best.chest - all;
      out.innerHTML = '<b>Size ' + best.size + '</b> is the closest. Your coat is ' + all.toFixed(0) + ' cm all round; ours is ' + best.chest + ' cm (' + (diff === 0 ? 'the same' : Math.abs(diff).toFixed(0) + ' cm ' + (diff > 0 ? 'roomier' : 'closer-fitting')) + ').';
    });
    new MutationObserver(function () { clearTimeout(window.__tpScT); window.__tpScT = setTimeout(update, 60); }).observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState !== 'loading') update(); else document.addEventListener('DOMContentLoaded', update);
  })();
  } catch(e) { console.error(e); }
})();

})();
